import { Button, Input, Table, Upload, message } from 'antd';
import { useEffect, useState } from 'react';
import { EmptyState } from '../../components/EmptyState';
import { migrationsApi, usersApi } from '../../services/resources';
import type { MigrationBatch } from '../../types/api';

export function AdminMigrationPage() {
  const [batches, setBatches] = useState<MigrationBatch[]>([]);
  const [selected, setSelected] = useState<MigrationBatch | null>(null);
  const [paste, setPaste] = useState('');

  async function load() {
    setBatches(await migrationsApi.list());
  }

  useEffect(() => {
    void load().catch(() => message.error('迁移批次失败'));
  }, []);

  return (
    <div className="stack">
      <h1 className="page-title">迁移核对</h1>
      <p className="meta">staging 不占正式房间。核对完成后再提交切换。</p>
      <Upload
        accept=".csv,.xlsx"
        beforeUpload={async (file) => {
          const text = await file.text();
          const rows = parseRows(text);
          await usersApi.import(rows);
          message.success('人员导入已提交');
          return false;
        }}
      >
        <Button className="touch">导入人员 CSV/xlsx</Button>
      </Upload>
      <Input.TextArea
        rows={4}
        value={paste}
        onChange={(e) => setPaste(e.target.value)}
        placeholder="或粘贴课表行 JSON 数组"
      />
      <Button
        className="touch"
        onClick={async () => {
          const rows = JSON.parse(paste || '[]') as object[];
          await migrationsApi.create({ kind: 'timetable', rows });
          await load();
        }}
      >
        上传 staging
      </Button>
      {batches.length === 0 ? (
        <EmptyState text="尚无迁移批次。" />
      ) : (
        <Table
          scroll={{ x: 620 }}
          rowKey="id"
          dataSource={batches}
          pagination={false}
          onRow={(row) => ({
            onClick: () => {
              void migrationsApi.get(row.id).then(setSelected);
            },
          })}
          columns={[
            { title: '批次', dataIndex: 'id' },
            { title: '类型', dataIndex: 'kind' },
            { title: '状态', dataIndex: 'status' },
          ]}
        />
      )}
      {selected ? (
        <section className="surface" style={{ padding: 16 }}>
          <h2>核对表</h2>
          <Table
            scroll={{ x: 620 }}
            rowKey="row_no"
            dataSource={selected.rows ?? []}
            pagination={false}
            columns={[
              { title: '行', dataIndex: 'row_no' },
              { title: '错误', dataIndex: 'error' },
            ]}
          />
          <Button className="touch" onClick={() => void migrationsApi.review(selected.id).then(load)}>
            标记已核对
          </Button>
          <Button className="touch" onClick={() => void migrationsApi.commit(selected.id).then(load)}>
            写入占用
          </Button>
          <Button type="primary" className="touch" onClick={() => void migrationsApi.cutover(selected.id).then(load)}>
            提交切换
          </Button>
        </section>
      ) : null}
    </div>
  );
}

function parseRows(text: string): { principal: string; name: string; role: string }[] {
  const lines = text.split(/\r?\n/).filter(Boolean);
  const out: { principal: string; name: string; role: string }[] = [];
  for (const line of lines.slice(1)) {
    const [principal, name, role] = line.split(/[,;\t]/).map((s) => s.trim());
    if (principal && name && role) out.push({ principal, name, role });
  }
  return out;
}
